import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-1" }
const _hoisted_2 = { class: "flex items-center space-x-2" }
const _hoisted_3 = { class: "text-md text-primary font-semibold" }
const _hoisted_4 = { class: "flex items-center space-x-2 text-sm text-gray-500" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "italic text-gray-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createBlock(_component_UiPanel, { class: "flex items-center justify-between px-4 py-3 transition-colors duration-150 hover:bg-white/80" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode($setup["SVGWhatsApp"], { class: "h-4 w-4 flex-shrink-0 text-[#25D366]" }),
          _createElementVNode("div", _hoisted_3, _toDisplayString($setup.applyPhoneMask($props.modelValue.number)), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _createVNode($setup["LocationMarkerIcon"], {
              class: "mr-1 h-4 w-4 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            ($props.modelValue.city && $props.modelValue.state)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($props.modelValue.city) + "/" + _toDisplayString($props.modelValue.state), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('number.types.null')), 1 /* TEXT */))
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_UiButton, {
          variant: "primary",
          "text-variant": "white",
          class: "hover:scale-102 flex items-center space-x-1 transition-transform duration-150",
          onClick: $setup.handleMonitorClick
        }, {
          default: _withCtx(() => [
            _createVNode($setup["EyeIcon"], {
              class: "mr-1 h-4 w-4",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('whatsappCode.monitor')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }))
}